export default "__VITE_ASSET__CBpguGIk__"